class YoutubeEmbedControl {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector('.js-youtube-stop')) {
      this.stop();
    }
  }

  event() {
  }
  
  iframeController(target, action, arg = '[]') {
    target.contentWindow.postMessage('{"event":"command", "func":"' + action + '", "args":' + arg + '}', '*');
}

  stop() {
    const stopBtns = document.querySelectorAll('.js-youtube-stop');

    stopBtns.forEach((btn)=>{
      btn.addEventListener('click',()=>{
        const youtubeEmbeds = document.querySelectorAll('.wp-block-embed.is-provider-youtube iframe');
        youtubeEmbeds.forEach((embed)=>{
          this.iframeController(embed,'stopVideo');
        })
      })
    })
  }

}